import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Button as ButtonIcon } from "@faire/web/slate/icons/foundation/Button";
import React from "react";
import { BrandReferralCreditDiscrepancyIA } from "../instantAnswers/referrals-brandReferralsCreditDiscrepancy";
import { BrandReferralEarnedCreditIA } from "../instantAnswers/referrals-brandReferralsEarnCredit";
import { BrandReferralHowDoReferralsWorkIA } from "../instantAnswers/referrals-brandReferralsHowDoReferralsWork";
import { BrandReferralHowToReferBrandIA } from "../instantAnswers/referrals-brandReferralsHowToReferBrand";
import { BrandReferralStatusIA } from "../instantAnswers/referrals-brandReferralsStatus";
import { BrandReferralUseCreditIA } from "../instantAnswers/referrals-brandReferralsUseCredit";
import { HowDoesSignupWorkIA } from "../instantAnswers/referrals-HowDoesSignupWork";
import { WhenDoesSignupExpireIA } from "../instantAnswers/referrals-whenDoesSignupExpire";
export var useReferralsRetailerNodes = function useReferralsRetailerNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var articles = useArticles();
  return {
    Referrals: {
      id: "Referrals",
      label: strictLocalize({
        id: "M0WiVO",
        defaultMessage: [{
          "type": 0,
          "value": "Doorverwijzingen"
        }]
      }),
      icon: /*#__PURE__*/React.createElement(ButtonIcon, {
        fontSize: "24px",
        color: "faireBlack"
      }),
      articles: [articles.Referrals.CAN_I_REFER_BRANDS_TO_FAIRE, articles.Referrals.USE_REFERRAL_PROMOTION],
      children: ["SignUpOfferFaireDirect", "ReferBrand"],
      level: 1,
      sidebarTitle: strictLocalize({
        id: "4+bbF4",
        defaultMessage: [{
          "type": 0,
          "value": "Probleem met doorverwijzing"
        }]
      })
    },
    SignUpOfferFaireDirect: {
      id: "SignUpOfferFaireDirect",
      label: strictLocalize({
        id: "o2g2nG",
        defaultMessage: [{
          "type": 0,
          "value": "Registratie-aanbieding (Faire Direct)"
        }]
      }),
      children: ["HowDoesSignupWork", "WhenDoesSignupExpire", "WhyNoSignupOffer"],
      level: 2
    },
    ReferBrand: {
      id: "ReferBrand",
      label: strictLocalize({
        id: "83wxuX",
        defaultMessage: [{
          "type": 0,
          "value": "Een merk doorverwijzen"
        }]
      }),
      children: ["BrandReferralsStatus", "BrandReferralsEarnCredit", "BrandReferralsUseCredit", "CreditDiscrepancy", "HowToReferBrand", "HowBrandReferralsWork"],
      level: 2
    },
    HowDoesSignupWork: {
      id: "HowDoesSignupWork",
      label: strictLocalize({
        id: "FXEwMX",
        defaultMessage: [{
          "type": 0,
          "value": "Hoe werkt de registratie-aanbieding?"
        }]
      }),
      articles: [articles.Referrals.USE_REFERRAL_PROMOTION],
      instantAnswer: HowDoesSignupWorkIA(strictLocalize),
      level: 3
    },
    WhenDoesSignupExpire: {
      id: "WhenDoesSignupExpire",
      label: strictLocalize({
        id: "rd31e3",
        defaultMessage: [{
          "type": 0,
          "value": "Wanneer verloopt mijn registratie-aanbieding"
        }]
      }),
      instantAnswer: WhenDoesSignupExpireIA(strictLocalize),
      level: 3
    },
    WhyNoSignupOffer: {
      id: "WhyNoSignupOffer",
      label: strictLocalize({
        id: "xqST3e",
        defaultMessage: [{
          "type": 0,
          "value": "Waarom heb ik de registratie-aanbieding niet ontvangen"
        }]
      }),
      instantAnswer: WhenDoesSignupExpireIA(strictLocalize),
      level: 3
    },
    BrandReferralsStatus: {
      id: "BrandReferralsStatus",
      label: strictLocalize({
        id: "iSZLbz",
        defaultMessage: [{
          "type": 0,
          "value": "Hoe je de status van merkdoorverwijzingen kunt bekijken"
        }]
      }),
      articles: [articles.Referrals.CAN_I_REFER_BRANDS_TO_FAIRE],
      instantAnswer: BrandReferralStatusIA(strictLocalize),
      level: 3
    },
    BrandReferralsEarnCredit: {
      id: "BrandReferralsEarnCredit",
      label: strictLocalize({
        id: "KvS6i7",
        defaultMessage: [{
          "type": 0,
          "value": "Zo verdien je tegoed aan merkdoorverwijzingen"
        }]
      }),
      articles: [articles.Referrals.CAN_I_REFER_BRANDS_TO_FAIRE],
      instantAnswer: BrandReferralEarnedCreditIA(strictLocalize),
      level: 3
    },
    BrandReferralsUseCredit: {
      id: "BrandReferralsUseCredit",
      label: strictLocalize({
        id: "7b3NED",
        defaultMessage: [{
          "type": 0,
          "value": "Zo gebruik je het tegoed van merkdoorverwijzingen"
        }]
      }),
      articles: [articles.Referrals.CAN_I_REFER_BRANDS_TO_FAIRE],
      instantAnswer: BrandReferralUseCreditIA(strictLocalize),
      level: 3
    },
    CreditDiscrepancy: {
      id: "CreditDiscrepancy",
      label: strictLocalize({
        id: "tKiExe",
        defaultMessage: [{
          "type": 0,
          "value": "Waarom is er een tegoedverschil?"
        }]
      }),
      articles: [articles.Referrals.CAN_I_REFER_BRANDS_TO_FAIRE],
      instantAnswer: BrandReferralCreditDiscrepancyIA(strictLocalize),
      level: 3
    },
    HowToReferBrand: {
      id: "HowToReferBrand",
      label: strictLocalize({
        id: "ENRJid",
        defaultMessage: [{
          "type": 0,
          "value": "Hoe kun je een merk doorverwijzen"
        }]
      }),
      articles: [articles.Referrals.CAN_I_REFER_BRANDS_TO_FAIRE],
      instantAnswer: BrandReferralHowToReferBrandIA(strictLocalize),
      level: 3
    },
    HowBrandReferralsWork: {
      id: "HowBrandReferralsWork",
      label: strictLocalize({
        id: "Mvesm2",
        defaultMessage: [{
          "type": 0,
          "value": "Hoe werken merkdoorverwijzingen"
        }]
      }),
      articles: [articles.Referrals.CAN_I_REFER_BRANDS_TO_FAIRE, articles.FAQ.BRAND_REFERRAL_PROGRAM_TERMS_CONDITIONS],
      instantAnswer: BrandReferralHowDoReferralsWorkIA(strictLocalize),
      level: 3
    }
  };
};